import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./Culture.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useCareersSection } from "../../../../context/CareersPageContext";
import { getCultureImagesFromSection } from "../../../../services/contentApi";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";

const Culture = () => {
  const { section, loading } = useCareersSection("culture");

  const images = useMemo(
    () => (section?.fields ? getCultureImagesFromSection(section) : []),
    [section]
  );

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const imageSrcs = images.map((url) => resolveMediaUrl(url)).filter(Boolean);

  return (
    <section className="culture">
      <div className="culture__container">
        <div className="culture__left">
          {fields.label ? (
            <CmsText
              content={fields.label}
              as="span"
              className="culture__label"
            />
          ) : null}

          {fields.title ? (
            <CmsText content={fields.title} as="h2" />
          ) : null}

          {fields.paragraph_1 ? (
            <RichTextContent content={fields.paragraph_1} as="p" />
          ) : null}
          {fields.paragraph_2 ? (
            <RichTextContent content={fields.paragraph_2} as="p" />
          ) : null}

          {fields.button_link ? (
            <Link to={fields.button_link} className="buttonclip culture__btn">
              <CmsText content={fields.button_text || "Learn more"} as="span" />
            </Link>
          ) : null}
        </div>

        {imageSrcs.length > 0 ? (
          <div className="culture__right">
            <div className="cccol1">
              {imageSrcs[0] ? (
                <div className="img img1">
                  <img src={imageSrcs[0]} alt="" />
                </div>
              ) : null}
              {imageSrcs[1] ? (
                <div className="img img2">
                  <img src={imageSrcs[1]} alt="" />
                </div>
              ) : null}
            </div>

            <div className="cccol2">
              {imageSrcs[2] ? (
                <div className="img img3">
                  <img src={imageSrcs[2]} alt="" />
                </div>
              ) : null}
              {imageSrcs[3] ? (
                <div className="img img4">
                  <img src={imageSrcs[3]} alt="" />
                </div>
              ) : null}
              {imageSrcs[4] ? (
                <div className="img img5">
                  <img src={imageSrcs[4]} alt="" />
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Culture;
